import { Loader } from 'ui';
import {
	ApplicationRoundType,
	ApplicationStatus,
	BulkActionByRecruiterInput,
	FilterRecommendationsInput,
	PositionStatus,
	PositionTitle,
	UIUserRecommendation,
	UserPlacementTags,
} from 'types';
import { Img } from 'react-image';
import React, { ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Select, { SingleValue } from 'react-select';
import { generatePositionTitle, locationPreferenceOptions, stringAvatar } from 'shared-utils';
import CandidateProfile from 'src/pages/CandidateProfile';
import { useMutation, useQueryClient } from 'react-query';
import RecruiterCandidateCard from './RecruiterCandidateCard';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import RecruiterCandidatesTabsComponent from './RecruiterCandidatesTabsComponent';
import {
	useGetPositionByIdQuery,
	useGetPositionUserRecommendationStatus,
	useGetPositionsForRecruiterQuery,
	useGetRecommendationsForPositionQuery,
} from 'src/hooks/position.hooks';
import PositionUnderReviewState from './PositionUnderReviewState';
import ConnectWithCandidateComponent from './ConnectWithCandidateComponent';
import NoRecommendedCandidatesState from './NoRecommendedCandidatesState';
import { useToast } from 'src/context/ToastProvider';
import SuccessPage from '../position/preview/SuccessPage';
import { sendTrackingEvent } from 'src/utils/gtm';
import RecruiterPositionDrawer from './RecruiterPositionDrawer';
import CloseRecruiterPositionConfirmationModal from './CloseRecruiterPositionConfirmationModal';
import CloseRecruiterPositionModal from './CloseRecruiterPositionModal';
import { Avatar, Button, Label, Radio, Spinner, TextInput, ToggleSwitch } from 'flowbite-react';
import { IoMdAdd } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import { BiSelectMultiple } from 'react-icons/bi';
import { TbSearch } from 'react-icons/tb';
import { HiMiniArrowLeft } from 'react-icons/hi2';
import { Drawer } from '../shared/Drawer';
import RecruiterShareCandidates from './RecruiterShareCandidates';
import RecruiterCandidatesFilters from './RecruiterCandidatesFilters';
import { bulkAction, shortlistUser } from 'src/apis/application';
import ViewAssignment from '../my-applications/assignment/ViewAssignment';
import ViewOffer from '../my-applications/offer/ViewOffer';
import { useUserContext } from 'src/context/UserProvider';
import RecruiterCandidatesBulkActionsOnConncetedUsers from './RecruiterCandidatesBulkActionsOnConncetedUsers';
import { Slide, useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import RecruiterPipelineTable from './RecruiterPipelineTable';
import RequestFurtherRecommendation from './RequestFurtherRecommendation';
import FilterDrawer from './filterDrawer/FilterDrawer';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import Draggable from 'react-draggable';
import { MdDragIndicator } from 'react-icons/md';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { getDumnyUser } from 'shared-utils';

import RecruiterThreeDotMenu from './RecruiterThreeDotMenu';
import RecruiterCreatePositionDrawer from './RecruiterCreatePositionDrawer';
import { debounce } from 'lodash';
import NewCreatingPositionLoader from '../position/NewCreatingPositionLoader';
import { getRecommendationsForPosition } from 'src/apis/position';
import RecruiterCandidateUndoReject from './RecruiterCandidateUndoReject';
import RecruiterCandidateUndoAutoReject from './RecruiterCandidateUndoAutoReject';

export enum CandidatesTabsEnum {
	RECOMMENDATIONS = 'recommendations',
	AUTO_RECOMMENDED = 'auto-recommended',
	CONNECTED = 'connected',
	REJECTED = 'rejected',
}
interface Props {
	isTourActive: boolean;
}

const RecruiterCandidatesContainer2 = ({ isTourActive }: Props) => {
	const navigate = useNavigate();
	const toast = useToast();
	const location = useLocation();
	const queryClient = useQueryClient();
	const { positionId, companyId } = useParams();
	const [searchParams, setSearchParams] = useSearchParams();
	const { user, isAccountManagerLoggedIn, isRecruiterLoggedIn } = useUserContext();
	const viewAssignment = searchParams.get('viewAssignment');
	const viewOffer = searchParams.get('viewOffer');
	const handler = searchParams.get('handler');
	const search = searchParams.get('search') || '';
	const defaultSelectedTab = searchParams.get('tab');
	const {
		setSelectedPositionId,
		setSelectedCompany,
		selectedCompany,
		companies,
		activeCompanies,
		recommendationsFilters,
		setRecommendationsFilters,
	} = useRecommendationsContext();
	const [position, setPosition] = useState<{ x: number; y: number } | undefined>({ x: 0, y: 0 });

	const [showMatchedOrShortListed, setShowMatchedOrShortListed] = useState(false);
	const [filterApplied, setFilterApplied] = useState(false);
	const [searchText, setSearchText] = useState('');

	const { data: positionsData, isLoading: isPositionsDataLoading } = useGetPositionsForRecruiterQuery(
		isAccountManagerLoggedIn,
		companyId,
	);
	const { data, isLoading, refetch } = useGetPositionByIdQuery(positionId);
	const {
		data: positionRecomendationData,
		isLoading: isPositionRecomendationDataLoading,
		isFetching: isFetchingRecommendations,
	} = useGetRecommendationsForPositionQuery({
		positionId: positionId ?? '',
		...recommendationsFilters,
		search,
	});

	const positionDetailNodeRef: React.MutableRefObject<HTMLDivElement | null> = useRef(null);

	const isMobile = useMediaQuery('(max-width:960px)');

	const [tab, setTab] = useState<CandidatesTabsEnum>(
		(defaultSelectedTab as CandidatesTabsEnum) || CandidatesTabsEnum.RECOMMENDATIONS,
	);
	const [totalRecommendations, setTotalRecommendations] = useState<number>(0);
	const [recommendationsState, setRecommendationsState] = useState<UIUserRecommendation[]>();
	const [filteredCandidates, setFilteredCandidates] = useState<UIUserRecommendation[]>([]);
	const [totalConections, setTotalConections] = useState<number>(0);
	const [hasUserConnected, setHasUserConnected] = useState<boolean>(false);
	const [recProfiles, setRecProfiles] = useState<{ handler: string; percentMatch: number }[]>([]);
	const [conProfiles, setConProfiles] = useState<{ handler: string; percentMatch: number }[]>([]);
	const [selectedProfileIndex, setSelectedProfileIndex] = useState<number | undefined>();
	const [positionDropdownOptions, setPositionDropdownOptions] = useState<
		{
			label: string;
			value: string;
		}[]
	>([]);

	const [showPositionDetail] = useState<boolean>(false);
	const [recruiterCreatePosDrawerOpen, setRecruiterCreatePosDrawerOpen] = useState<boolean>(false);
	const [, setPositionDetailNodeRefClientHeight] = useState<number>(0);
	const [isPositionDrawerOpen, setIsPositionDrawerOpen] = useState<boolean>(false);
	const [isCloseRecruiterPositionConfirmationModalOpen, setIsCloseRecruiterPositionConfirmationModalOpen] =
		useState<boolean>(false);
	const [isCloseRecruiterPositionModal, setIsCloseRecruiterPositionModal] = useState<boolean>(false);
	const [bulkSelect, setBulkSelect] = useState<boolean>(false);
	const [defaultBulkAction, setDefaultBulkAction] = useState<BulkActionByRecruiterInput['action'] | null>();
	const [bulkSelectedCandidates, setBulkSelectedCandidates] = useState<UIUserRecommendation[]>([]);
	const [showShareCandidatesForm, setShowShareCandidatesForm] = useState(false);
	const [, setShowFilterDrawer] = useState(false);
	const [selectedAction, setSelectedAction] = useState('');
	const [hideRecommendations, setHideRecommendations] = useState(
		user?.flags?.hideRecommendations && isRecruiterLoggedIn,
	);
	const positionHasExpired = dayjs().isAfter(data?.position?.expiresAt);

	const searchChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLInputElement>) => {
		searchParams.set('search', event.target.value);
		searchParams.set('tab', tab);
		setSearchParams(searchParams);
	};

	const debouncedSearchChangeHandler = useCallback(debounce(searchChangeHandler, 1000), [search]);

	const handleViewProfile = (handler: string) => {
		searchParams.set('handler', handler);
		setSearchParams(searchParams);
	};

	const resetPosition = () => {
		setPosition({ x: 0, y: 0 });
	};

	useEffect(() => {
		setTab((defaultSelectedTab as CandidatesTabsEnum) || CandidatesTabsEnum.RECOMMENDATIONS);
	}, [defaultSelectedTab]);

	useEffect(() => {
		if (user?.flags?.hideRecommendations && isRecruiterLoggedIn) {
			setTab(CandidatesTabsEnum.CONNECTED);
			setHideRecommendations(true);
		} else setHideRecommendations(false);
	}, [user, isRecruiterLoggedIn]);

	useEffect(() => {
		setBulkSelect(false);
		resetPosition();
		setBulkSelectedCandidates([]);
	}, [location]);

	useEffect(() => {
		setSelectedPositionId(positionId);
		const company = companies?.find(company => company.company._id === companyId);
		if (company) {
			setSelectedCompany(company);
		} else {
			const activeCompany = activeCompanies?.find(company => company.company._id === companyId);
			if (activeCompany) setSelectedCompany(activeCompany);
		}
	}, [positionId]);

	useGetPositionUserRecommendationStatus({ positionId: positionId ?? '', handler: handler ?? '' }, data => {
		setHasUserConnected(data.hasConnected ?? false);
	});

	// not shortlisted => shortlist
	const shortListUserFn = useMutation(['shortlistUser'], shortlistUser, {
		onSuccess() {
			toast({
				title: 'User Shortlisted successfully',
				type: 'success',
			});
			queryClient.invalidateQueries(['getRecommendationsForPosition', positionId]);
			queryClient.refetchQueries(['getRecommendationsForPosition', positionId]);
		},
		onError(error: Error) {
			toast({
				title: `Error occured while shortlisting candidate ${error.message}`,
				type: 'error',
			});
		},
	});

	// bulk action for shortlist
	const bulkActionFn = useMutation(['bulkAction'], bulkAction, {
		onSuccess: async (data: any) => {
			// First, check if there's a limit reached error (regardless of action type)
			const limitReachedError = data.errors?.find((err: string) =>
				err.includes('Cannot undo rejection. Maximum limit of 2 undo rejections has been reached for this candidate.')
			);

			if (limitReachedError) {
				// Extract the message part (remove application ID prefix if present)
				const cleanMessage = limitReachedError.includes(': ')
					? limitReachedError.split(': ').slice(1).join(': ')
					: limitReachedError;

				toast({
					title: cleanMessage,
					type: 'error',
					duration: 6000,
				});
				// Invalidate and refetch all queries related to recommendations for this position
				await queryClient.invalidateQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
				await queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
				resetPosition();
				setBulkSelect(false);
				setBulkSelectedCandidates([]);
				setDefaultBulkAction(null);
				return;
			}

			if (data.action === 'download-resumes') {
				const zip = new JSZip();
				for (let resume of data.resumes) {
					// check if file name ends with extension .pdf
					// if not then add .pdf to the file name
					if (!resume.fileName.endsWith('.pdf')) {
						resume.fileName = `${resume.fileName}.pdf`;
					}
					zip.file(resume.fileName, resume.content.data);
				}

				const zipBlob = await zip.generateAsync({ type: 'blob' });
				saveAs(zipBlob, 'resumes.zip');
				toast({
					title: 'Resumes downloaded successfully',
					type: 'success',
				});
			} else if (data.action === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-reject') {
				// Handle partial success/failure for bulk undo reject
				if (data.failure > 0 || data.errors?.length > 0) {
					// Show general error handling
					const errorMessages = data.errors?.slice(0, 3).join(', ') || '';
					const errorText = errorMessages.length > 100 ? errorMessages.substring(0, 100) + '...' : errorMessages;
					toast({
						title: data.message || `Successfully processed ${data.success || 0} candidates. ${data.failure || 0} failed.${errorText ? ` Errors: ${errorText}` : ''}`,
						type: data.success > 0 ? 'warning' : 'error',
						duration: 6000,
					});
				} else {
					toast({
						title: 'Candidates added back to pipeline successfully',
						type: 'success',
					});
				}
			} else if (data.action === 'bulk-undo-auto-reject' || defaultBulkAction === 'bulk-undo-auto-reject') {
				// Handle partial success/failure for bulk undo auto reject
				if (data.failure > 0 || data.errors?.length > 0) {
					// Show general error handling
					const errorMessages = data.errors?.slice(0, 3).join(', ') || '';
					const errorText = errorMessages.length > 100 ? errorMessages.substring(0, 100) + '...' : errorMessages;
					toast({
						title: data.message || `Successfully processed ${data.success || 0} candidates. ${data.failure || 0} failed.${errorText ? ` Errors: ${errorText}` : ''}`,
						type: data.success > 0 ? 'warning' : 'error',
						duration: 6000,
					});
				} else {
					toast({
						title: 'Candidates added back to pipeline successfully',
						type: 'success',
					});
				}
			} else {
				toast({
					title: 'Candidates shortlisted successfully',
					type: 'success',
				});
			}

			// Invalidate and refetch all queries related to recommendations for this position
			// This ensures the UI updates immediately after bulk actions
			await queryClient.invalidateQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
			await queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
			resetPosition();
			setBulkSelect(false);
			setBulkSelectedCandidates([]);
			setDefaultBulkAction(null);
		},
		onError(error: Error) {
			toast({
				title: `Error occured ${error.message}`,
				type: 'error',
			});
		},
	});

	// Mutation for removing individual filters
	const removeFilterFn = useMutation(['getRecommendationsForPositionFilter'], getRecommendationsForPosition, {
		onSuccess(data) {
			queryClient.setQueryData(['getRecommendationsForPosition', positionId], data);
		},
		onError(err: any) {
			toast({
				title: err.message,
				type: 'error',
				duration: 5000,
			});
		},
	});

	// Helper function to get active filter chips
	const getActiveFilterChips = useCallback(() => {
		if (!recommendationsFilters || !filterApplied) return [];

		const chips: Array<{ label: string; filterKey: keyof FilterRecommendationsInput; value?: string }> = [];

		// Round Movement
		if (recommendationsFilters.roundMovement) {
			const roundMovementLabels: Record<string, string> = {
				NotStarted: 'Not Started',
				Ongoing: 'Ongoing Rounds',
				Rejected: 'Rejected',
				AutoRejected: 'Auto Rejected',
				PlacedElsewhere: 'Placed Elsewhere',
				Placed: 'Placed',
			};
			chips.push({
				label: `Round Movement: ${roundMovementLabels[recommendationsFilters.roundMovement] || recommendationsFilters.roundMovement}`,
				filterKey: 'roundMovement',
			});
		}

		// Recommendation Type
		if (recommendationsFilters.recommendationTypeFilter) {
			const typeLabels: Record<string, string> = {
				auto: 'Auto',
				manual: 'Manual',
				both: 'Both',
			};
			chips.push({
				label: `Recommendation Type: ${typeLabels[recommendationsFilters.recommendationTypeFilter] || recommendationsFilters.recommendationTypeFilter}`,
				filterKey: 'recommendationTypeFilter',
			});
		}

		// Rejected Type (only show when on rejected tab)
		if (recommendationsFilters.rejectedTypeFilter && tab === CandidatesTabsEnum.REJECTED) {
			const rejectedTypeLabels: Record<string, string> = {
				recommendations: 'Recommendations',
				applicants: 'Applicants',
				both: 'Both',
			};
			chips.push({
				label: `Rejected Type: ${rejectedTypeLabels[recommendationsFilters.rejectedTypeFilter] || recommendationsFilters.rejectedTypeFilter}`,
				filterKey: 'rejectedTypeFilter',
			});
		}

		// Placement Statuses
		if (recommendationsFilters.placementStatuses) {
			try {
				const statuses = JSON.parse(recommendationsFilters.placementStatuses);
				if (Array.isArray(statuses) && statuses.length > 0) {
					statuses.forEach((status: string) => {
						const label = status.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').trim();
						chips.push({
							label: `Placement Status: ${label}`,
							filterKey: 'placementStatuses',
							value: status,
						});
					});
				}
			} catch (e) {
				// Ignore parse errors
			}
		}

		// Candidate Type (jobSeekerSubroles)
		if (recommendationsFilters.jobSeekerSubroles) {
			try {
				const subroles = JSON.parse(recommendationsFilters.jobSeekerSubroles);
				if (Array.isArray(subroles) && subroles.length > 0) {
					subroles.forEach((subrole: string) => {
						chips.push({
							label: `Candidate Type: ${subrole}`,
							filterKey: 'jobSeekerSubroles',
							value: subrole,
						});
					});
				}
			} catch (e) {
				// Ignore parse errors
			}
		}

		// Locations
		if (recommendationsFilters.locations) {
			try {
				const locations = JSON.parse(recommendationsFilters.locations);
				if (Array.isArray(locations) && locations.length > 0) {
					locations.forEach((location: string) => {
						chips.push({
							label: `Location: ${location}`,
							filterKey: 'locations',
							value: location,
						});
					});
				}
			} catch (e) {
				// Ignore parse errors
			}
		}

		// Ongoing Rounds
		if (recommendationsFilters.currentRounds) {
			try {
				const rounds = JSON.parse(recommendationsFilters.currentRounds);
				if (Array.isArray(rounds) && rounds.length > 0) {
					rounds.forEach((round: string) => {
						chips.push({
							label: `Ongoing Round: ${round}`,
							filterKey: 'currentRounds',
							value: round,
						});
					});
				}
			} catch (e) {
				// Ignore parse errors
			}
		}

		// Round Type
		if (recommendationsFilters.roundType) {
			const roundTypeLabels: Record<string, string> = {
				[ApplicationRoundType.Assignment]: 'Assignment',
				[ApplicationRoundType.Interview]: 'Interview',
				[ApplicationRoundType.OnlineTest]: 'Online Test',
				Any: 'Any',
			};
			chips.push({
				label: `Round Type: ${roundTypeLabels[recommendationsFilters.roundType] || recommendationsFilters.roundType}`,
				filterKey: 'roundType',
			});
		}

		// Available to join
		if (recommendationsFilters.expectedJoining) {
			const joiningLabels: Record<string, string> = {
				Immediate: 'Immediate',
				Within_1_month: 'Within 1 month',
				Within_3_months: 'Within 3 months',
				Any: 'Any',
			};
			chips.push({
				label: `Available to join: ${joiningLabels[recommendationsFilters.expectedJoining] || recommendationsFilters.expectedJoining}`,
				filterKey: 'expectedJoining',
			});
		}

		// Interested Candidates
		if (recommendationsFilters.showInterestedCandidates) {
			chips.push({
				label: 'Interested Candidates Only',
				filterKey: 'showInterestedCandidates',
			});
		}

		return chips;
	}, [recommendationsFilters, filterApplied, tab]);

	// Check if there are any active filters
	const hasActiveFilters = useMemo(() => {
		if (!recommendationsFilters) return false;

		// Check simple filter fields
		if (
			recommendationsFilters.roundMovement ||
			recommendationsFilters.recommendationTypeFilter ||
			recommendationsFilters.rejectedTypeFilter ||
			recommendationsFilters.roundType ||
			recommendationsFilters.expectedJoining ||
			recommendationsFilters.showInterestedCandidates
		) {
			return true;
		}

		// Check array-based filters (parse JSON strings and verify they're not empty)
		const checkArrayFilter = (filterValue: string | undefined): boolean => {
			if (!filterValue) return false;
			try {
				const parsed = JSON.parse(filterValue);
				return Array.isArray(parsed) && parsed.length > 0;
			} catch (e) {
				return false;
			}
		};

		if (
			checkArrayFilter(recommendationsFilters.placementStatuses) ||
			checkArrayFilter(recommendationsFilters.jobSeekerSubroles) ||
			checkArrayFilter(recommendationsFilters.locations) ||
			checkArrayFilter(recommendationsFilters.currentRounds)
		) {
			return true;
		}

		return false;
	}, [recommendationsFilters]);

	// Sync filterApplied state with hasActiveFilters when recommendationsFilters changes
	useEffect(() => {
		setFilterApplied(hasActiveFilters);
	}, [hasActiveFilters]);

	// Handle removing a filter chip
	const handleRemoveFilter = useCallback(
		(filterKey: keyof FilterRecommendationsInput, value?: string) => {
			if (!recommendationsFilters || !positionId) return;

			const updatedFilters = { ...recommendationsFilters };

			if (filterKey === 'roundMovement' || filterKey === 'recommendationTypeFilter' || filterKey === 'rejectedTypeFilter' || filterKey === 'roundType' || filterKey === 'expectedJoining') {
				delete updatedFilters[filterKey];
			} else if (filterKey === 'showInterestedCandidates') {
				updatedFilters.showInterestedCandidates = false;
			} else if (filterKey === 'placementStatuses' && recommendationsFilters.placementStatuses) {
				try {
					const statuses = JSON.parse(recommendationsFilters.placementStatuses);
					if (Array.isArray(statuses) && value) {
						const filtered = statuses.filter((s: string) => s !== value);
						if (filtered.length === 0) {
							delete updatedFilters.placementStatuses;
						} else {
							updatedFilters.placementStatuses = JSON.stringify(filtered);
						}
					} else {
						delete updatedFilters.placementStatuses;
					}
				} catch (e) {
					delete updatedFilters.placementStatuses;
				}
			} else if (filterKey === 'jobSeekerSubroles' && recommendationsFilters.jobSeekerSubroles) {
				try {
					const subroles = JSON.parse(recommendationsFilters.jobSeekerSubroles);
					if (Array.isArray(subroles) && value) {
						const filtered = subroles.filter((s: string) => s !== value);
						if (filtered.length === 0) {
							delete updatedFilters.jobSeekerSubroles;
						} else {
							updatedFilters.jobSeekerSubroles = JSON.stringify(filtered);
						}
					} else {
						delete updatedFilters.jobSeekerSubroles;
					}
				} catch (e) {
					delete updatedFilters.jobSeekerSubroles;
				}
			} else if (filterKey === 'locations' && recommendationsFilters.locations) {
				try {
					const locations = JSON.parse(recommendationsFilters.locations);
					if (Array.isArray(locations) && value) {
						const filtered = locations.filter((l: string) => l !== value);
						if (filtered.length === 0) {
							delete updatedFilters.locations;
						} else {
							updatedFilters.locations = JSON.stringify(filtered);
						}
					} else {
						delete updatedFilters.locations;
					}
				} catch (e) {
					delete updatedFilters.locations;
				}
			} else if (filterKey === 'currentRounds' && recommendationsFilters.currentRounds) {
				try {
					const rounds = JSON.parse(recommendationsFilters.currentRounds);
					if (Array.isArray(rounds) && value) {
						const filtered = rounds.filter((r: string) => r !== value);
						if (filtered.length === 0) {
							delete updatedFilters.currentRounds;
						} else {
							updatedFilters.currentRounds = JSON.stringify(filtered);
						}
					} else {
						delete updatedFilters.currentRounds;
					}
				} catch (e) {
					delete updatedFilters.currentRounds;
				}
			}

			setRecommendationsFilters(updatedFilters);

			// Check if there are any remaining filters (same logic as hasActiveFilters)
			const checkArrayFilter = (filterValue: string | undefined): boolean => {
				if (!filterValue) return false;
				try {
					const parsed = JSON.parse(filterValue);
					return Array.isArray(parsed) && parsed.length > 0;
				} catch (e) {
					return false;
				}
			};

			const hasRemainingFilters = !!(
				updatedFilters.roundMovement ||
				updatedFilters.recommendationTypeFilter ||
				updatedFilters.rejectedTypeFilter ||
				updatedFilters.roundType ||
				updatedFilters.expectedJoining ||
				updatedFilters.showInterestedCandidates ||
				checkArrayFilter(updatedFilters.placementStatuses) ||
				checkArrayFilter(updatedFilters.jobSeekerSubroles) ||
				checkArrayFilter(updatedFilters.locations) ||
				checkArrayFilter(updatedFilters.currentRounds)
			);

			// Update filterApplied state
			setFilterApplied(hasRemainingFilters);

			removeFilterFn.mutate({
				...updatedFilters,
				positionId,
			});
		},
		[recommendationsFilters, positionId, setRecommendationsFilters, removeFilterFn],
	);

	const activeFilterChips = getActiveFilterChips();

	const handleConnect = () => {
		sendTrackingEvent({
			event: 'recr_position_connect',
			eventLabel: location.pathname,
		});
		shortListUserFn.mutate({
			positionId: positionId ?? '',
			userId: recommendationsState?.find(r => r.user?.handler === handler)?.user?._id ?? '',
		});
	};

	// const setRefetchInterval = () => {
	// 	const refetchInterval = setInterval(() => {
	// 		console.log({ filterApplied });
	// 		refetchRecommendations();
	// 	}, 10 * 1000);
	// 	intervalRef.current = refetchInterval;
	// };

	// useEffect(() => {
	// 	if (filterApplied && intervalRef.current) {
	// 		console.log({ filterApplied });
	// 		clearInterval(intervalRef.current);
	// 		intervalRef.current = null;
	// 	} else if (!filterApplied && !intervalRef.current) {
	// 		setRefetchInterval();
	// 	}
	// }, [filterApplied]);

	const [totalAutoRecommended, setTotalAutoRecommended] = useState<number>(0);
	const [totalRejected, setTotalRejected] = useState<number>(0);

	useEffect(() => {
		if (positionRecomendationData?.position) {
			// Use rejectedUsers from API (backend handles filtering and ensures valid application documents)
			// Separate into Recommendations and Applicants based on history for accurate counting
			const allRejectedUsersForCount = positionRecomendationData?.rejectedUsers || [];

			const rejectedFromRecommendations = allRejectedUsersForCount.filter(
				(r: UIUserRecommendation) =>
					// Never had SHORTLISTED status in history
					!r.application?.history?.some((h: any) => h.newStatus === ApplicationStatus.SHORTLISTED),
			);

			const rejectedFromApplicants = allRejectedUsersForCount.filter(
				(r: UIUserRecommendation) =>
					// Had SHORTLISTED status in history (even if current status is REJECTED)
					r.application?.history?.some((h: any) => h.newStatus === ApplicationStatus.SHORTLISTED),
			);

			// Calculate total rejected count based on filter
			// If filter is applied, show filtered count; otherwise show all
			const rejectedTypeFilter = recommendationsFilters?.rejectedTypeFilter;
			let totalRejectedCount: number;
			if (rejectedTypeFilter === 'recommendations') {
				totalRejectedCount = rejectedFromRecommendations.length;
			} else if (rejectedTypeFilter === 'applicants') {
				totalRejectedCount = rejectedFromApplicants.length;
			} else {
				// 'both' or undefined - show all
				totalRejectedCount = allRejectedUsersForCount.length;
			}

			// Calculate recommendations count excluding rejected users (they should only appear in Rejected tab)
			const recommendationsCount =
				(positionRecomendationData.interestedUsers?.filter(
					r =>
						r.application?.status !== ApplicationStatus.REJECTED &&
						r.application?.status !== ApplicationStatus.AUTO_REJECTED,
				).length || 0) +
				(positionRecomendationData.recommendedUsers?.filter(
					r =>
						r.application?.status !== ApplicationStatus.REJECTED &&
						r.application?.status !== ApplicationStatus.AUTO_REJECTED,
				).length || 0);

			// Calculate connected/applicants count excluding rejected users (they should only appear in Rejected tab)
			const connectedCount =
				positionRecomendationData?.connectedUsers?.filter(
					r =>
						r.application?.status !== ApplicationStatus.REJECTED &&
						r.application?.status !== ApplicationStatus.AUTO_REJECTED,
				).length || 0;

			const autoRecommended = positionRecomendationData?.autoRecommendedUsers?.length || 0;

			setTotalRecommendations(recommendationsCount);
			setTotalConections(connectedCount);
			setTotalAutoRecommended(autoRecommended);
			setTotalRejected(totalRejectedCount);
		}
	}, [positionRecomendationData, recommendationsFilters?.rejectedTypeFilter]);

	useEffect(() => {
		if (data?.position) {
			const recommendations =
				data?.recommendations
					?.filter(el => !el.hasConnected)
					.map(r => ({
						handler: r.user?.handler,
						percentMatch: r.percentageMatch,
					})) ?? [];

			const connected =
				data?.recommendations
					?.filter(el => el.hasConnected)
					?.map(r => ({
						handler: r.user?.handler,
						percentMatch: r.percentageMatch,
					})) ?? [];
			setConProfiles(connected);
			setRecProfiles(recommendations);
		}
	}, [data]);

	useEffect(() => {
		const temp = positionsData?.positions
			?.filter(p => p.position.positionStatus === PositionStatus.OPEN)
			.map(p => ({
				label: generatePositionTitle(p.position.title as PositionTitle),
				value: String(p.position._id),
			}));
		if (temp?.length) {
			setPositionDropdownOptions(temp);
		}
	}, [positionsData]);

	useEffect(() => {
		const combinedRecommendations: UIUserRecommendation[] = (positionRecomendationData?.interestedUsers ?? []).concat(
			positionRecomendationData?.recommendedUsers ?? [],
		);
		let filteredData: UIUserRecommendation[] = combinedRecommendations;
		setRecommendationsState(filteredData);

		if (hideRecommendations && tab === CandidatesTabsEnum.RECOMMENDATIONS) {
			searchParams.set('tab', CandidatesTabsEnum.CONNECTED);
			setSearchParams(searchParams);

			if (hideRecommendations && !positionHasExpired && positionRecomendationData?.connectedUsers?.length) {
				const dummyData = getDumnyUser();
				filteredData = positionRecomendationData?.connectedUsers?.length
					? [...positionRecomendationData?.connectedUsers, dummyData]
					: [];
			} else {
				filteredData = positionRecomendationData?.connectedUsers ?? [];
			}
		} else if (!location.pathname.includes('pipeline')) {
			if (tab === CandidatesTabsEnum.RECOMMENDATIONS) {
				// Filter out rejected users from Recommendations tab - they should only appear in Rejected tab
				filteredData = combinedRecommendations.filter(
					r =>
						r.application?.status !== ApplicationStatus.REJECTED &&
						r.application?.status !== ApplicationStatus.AUTO_REJECTED,
				);

				if (showMatchedOrShortListed) {
					filteredData = filteredData?.filter(r => r.hasConnected) ?? [];
				}

			} else if (tab === CandidatesTabsEnum.AUTO_RECOMMENDED) {
				// Show only auto-recommended users (no Application/UserRecommendation documents yet)
				filteredData = positionRecomendationData?.autoRecommendedUsers ?? [];

			} else if (tab === CandidatesTabsEnum.CONNECTED) {
				// Filter out rejected users from Applicants tab - they should only appear in Rejected tab
				const connectedUsersFiltered = (positionRecomendationData?.connectedUsers || []).filter(
					r =>
						r.application?.status !== ApplicationStatus.REJECTED &&
						r.application?.status !== ApplicationStatus.AUTO_REJECTED,
				);

				if (hideRecommendations && !positionHasExpired && connectedUsersFiltered?.length) {
					const dummyData = getDumnyUser();
					filteredData = connectedUsersFiltered?.length
						? [...connectedUsersFiltered, dummyData]
						: [];
				} else {
					filteredData = connectedUsersFiltered;
				}
			} else if (tab === CandidatesTabsEnum.REJECTED) {
				// Use rejectedUsers from API (backend handles filtering and ensures valid application documents)
				// Backend already deduplicates and ensures all users have valid application documents
				const allRejectedUsers = positionRecomendationData?.rejectedUsers || [];

				// Separate into Recommendations and Applicants based on history for UI differentiation
				// Recommendations: rejected users who were NEVER shortlisted
				const rejectedFromRecommendations = allRejectedUsers.filter(
					(r: UIUserRecommendation) =>
						// Never had SHORTLISTED status in history
						!r.application?.history?.some((h: any) => h.newStatus === ApplicationStatus.SHORTLISTED),
				);

				// Applicants: rejected users who WERE shortlisted at some point
				const rejectedFromApplicants = allRejectedUsers.filter(
					(r: UIUserRecommendation) =>
						// Had SHORTLISTED status in history (even if current status is REJECTED)
						r.application?.history?.some((h: any) => h.newStatus === ApplicationStatus.SHORTLISTED),
				);

				// Apply rejectedTypeFilter if specified (only when on rejected tab)
				const rejectedTypeFilter = tab === CandidatesTabsEnum.REJECTED ? recommendationsFilters?.rejectedTypeFilter : undefined;
				if (rejectedTypeFilter === 'recommendations') {
					filteredData = rejectedFromRecommendations;
				} else if (rejectedTypeFilter === 'applicants') {
					filteredData = rejectedFromApplicants;
				} else {
					// 'both' or undefined - show all
					filteredData = [...rejectedFromRecommendations, ...rejectedFromApplicants];
				}
			}
		} else {
			filteredData = positionRecomendationData?.inPipeLineUsers ?? [];
		}
		// if (searchText) {
		// 	filteredData = filteredData.filter(p => {
		// 		if (searchText.includes(',')) {
		// 			const searchTextArray = searchText.split(',');
		// 			return searchTextArray.some(text =>
		// 				Object.values(p.user).some(value => String(value).toLowerCase().includes(text.trim().toLowerCase())),
		// 			);
		// 		}
		// 		return Object.values(p.user).some(value => String(value).toLowerCase().includes(searchText.toLowerCase()));
		// 	});
		// }

		setFilteredCandidates(filteredData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		positionRecomendationData,
		tab,
		searchText,
		showMatchedOrShortListed,
		data?.position?.expiresAt,
		location.pathname,
		isRecruiterLoggedIn,
		user?.flags?.hideRecommendations,
		recommendationsFilters?.rejectedTypeFilter,
	]);

	useEffect(() => {
		const userRecommendation = filteredCandidates?.find(r => r.user?.handler === handler);

		if (userRecommendation && filteredCandidates) {
			const hasConnected = userRecommendation.hasConnected;
			setHasUserConnected(hasConnected);
			if (hasConnected)
				setSelectedProfileIndex(Math.max(0, filteredCandidates?.findIndex(cp => cp.user.handler === handler)));
			else setSelectedProfileIndex(Math.max(0, filteredCandidates?.findIndex(rp => rp.user.handler === handler)));
		} else {
			setSelectedProfileIndex(undefined);
		}
	}, [filteredCandidates, conProfiles, recProfiles, handler]);

	useEffect(() => {
		const targetDiv = document.querySelector(`[data-div-id="${handler}"]`);
		if (targetDiv && !isMobile) {
			targetDiv.scrollIntoView({ behavior: 'smooth' });
		}
	}, [handler, isMobile]);

	useEffect(() => {
		// seting setBulkSelect as false on esc key press
		const handleEsc = (event: KeyboardEvent) => {
			if (event.key === 'Escape') {
				setBulkSelect(false);
				setBulkSelectedCandidates([]);
			}
		};
		document.addEventListener('keydown', handleEsc);
	}, []);

	useEffect(() => {
		setPositionDetailNodeRefClientHeight(positionDetailNodeRef.current?.clientHeight ?? 0);
	}, [showPositionDetail]);

	if (
		(isLoading || (isPositionRecomendationDataLoading && !search)) &&
		(!filterApplied || !isFetchingRecommendations)
	) {
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
		);
	}

	const isRecommendationsPage = !location.pathname.includes('pipeline') && (tab === CandidatesTabsEnum.RECOMMENDATIONS || tab === CandidatesTabsEnum.AUTO_RECOMMENDED || tab === CandidatesTabsEnum.REJECTED);

	if (viewAssignment) {
		const connectedUser = positionRecomendationData?.connectedUsers?.find(
			r => r.application?.ongoingRound?._id && String(r.application?.ongoingRound?._id) === viewAssignment,
		);
		if (connectedUser?.application) {
			return (
				<ViewAssignment
					application={connectedUser?.application}
					applicationUser={connectedUser?.user}
					positionId={positionId}
				/>
			);
		}
	} else if (viewOffer) {
		const application = positionRecomendationData?.connectedUsers?.find(
			r => r.application?._id && String(r.application?._id) === viewOffer,
		)?.application;
		if (application) {
			const jobSeekerUserId = application?.user?._id || application?.user;

			return (
				<div className="py-[16px]">
					<ViewOffer
						positionTitle={positionRecomendationData.position?.title}
						companyName={positionRecomendationData.position?.company.name}
						application={application}
						positionId={positionId}
						positionWorkingMode={positionRecomendationData.position?.workingMode}
						jobSeekerUser={positionRecomendationData.inPipeLineUsers?.find(u => u?.user?._id === jobSeekerUserId)?.user}
					/>
				</div>
			);
		}
	}

	const displayRecommendations = filterApplied
		? true
		: isAccountManagerLoggedIn ||
		Number(positionRecomendationData?.connectedUsers?.length) +
		Number(positionRecomendationData?.interestedUsers?.length) +
		Number(positionRecomendationData?.recommendedUsers?.length) >
		2;

	const pageTitle =
		(location.pathname.includes('pipeline')
			? 'Pipeline'
			: location.pathname.includes('candidates')
				? 'Candidates'
				: 'Positions') +
		(isAccountManagerLoggedIn ? ` at ${data?.position?.company?.name || selectedCompany?.company?.name || ''}` : '');

	return (
		<>
			{true ? (
				<>
					<div className="flex sm:flex-col gap-7 sm:gap-2 md:items-center md:py-2 md:pt-6 border-b-[0px] border-[#555770] border-solid ">
						{/* Heading for account manager on Mobile only */}
						{isAccountManagerLoggedIn && selectedProfileIndex === undefined ? (
							<p className="md:hidden text-lg font-inter font-[600] text-[#28293D] whitespace-pre mt-2">{pageTitle}</p>
						) : null}

						{selectedProfileIndex !== undefined ? (
							<div className="hidden md:flex items-center w-full text-lg font-semibold dark:text-white gap-3 md:pb-2 md:border-b border-[#E4E4EB]">
								<div
									className="flex items-center gap-3 cursor-pointer"
									onClick={() => {
										searchParams.delete('handler');
										setSearchParams(searchParams);
										setSelectedProfileIndex(undefined);
										refetch();
									}}
								>
									<Img src={'/assets/arrowLeft.svg'} className="cursor-pointer" />
									All Candidates
								</div>
							</div>
						) : (
							<div
								className={classNames(
									'flex items-center w-full text-lg font-semibold dark:text-white gap-3 md:pb-2 md:border-b border-[#E4E4EB]',
									isAccountManagerLoggedIn ? '' : 'mt-[10px] md:mt-0',
								)}
							>
								{/* Heading for Recuiter and account manager for desktop only */}
								<p className="hidden md:flex whitespace-pre">{pageTitle}</p>

								<div className="flex items-center justify-between w-[100%] gap-[16px]">
									<div className="w-full flex gap-[12px] whiteBgSelect ">
										{isPositionsDataLoading ? (
											<div className="w-full md:w-[306px] bg-slate-300 rounded-[8px] animate-pulse"></div>
										) : (
											<Select
												className="w-full md:w-[306px] !font-[400] !text-[16px]"
												menuPlacement={'auto'}
												classNamePrefix="my-select-plans"
												closeMenuOnSelect
												options={positionDropdownOptions}
												value={positionDropdownOptions.find(o => o.value === positionId)}
												onChange={(
													val: SingleValue<{
														label: string;
														value: string;
													}>,
												) => {
													if (val?.value) {
														navigate(
															`/${location.pathname.includes('pipeline') ? 'pipeline' : 'positions'}/${isAccountManagerLoggedIn ? `${companyId}/` : ''
															}${val.value}${location.pathname.includes('pipeline') ? '' : '/candidates'}`,
														);
													}
												}}
											/>
										)}

										<Button
											className="text-[#1C1C28] rounded-[8px] p-[8px] [&>span]:!p-0"
											color="light"
											disabled={
												positionRecomendationData?.position?.company?.isBlacklisted ||
												selectedCompany?.company?.isBlacklisted
											}
											onClick={() => {
												navigate(`/create-position${isAccountManagerLoggedIn ? `/${companyId}` : ''}`);
											}}
										>
											<IoMdAdd className="w-[24px] h-[24px]" />
										</Button>
										{isAccountManagerLoggedIn ? (
											<div className="hidden md:flex items-center text-sm font-medium italic">
												(Total Active Processes:{' '}
												{data?.recommendations?.reduce((acc, rec) => {
													if (rec.isProcessActive && rec.hasConnected) {
														return acc + 1;
													}
													return acc;
												}, 0) || 0}
												)
											</div>
										) : null}
									</div>
									{isAccountManagerLoggedIn && (
										<RecruiterThreeDotMenu
											positionId={data?.position?._id}
											hasSlackChannel={data?.position?.slackChannelId ? true : false}
											existingSlackWorkspaceIds={(data?.position?.slackChannels || []).map(sc => sc.workspaceid)}
										/>
									)}
								</div>
							</div>
						)}

						{/* show position level if position is published */}
						{/* {data?.position?.isPublished ? (
							<div className="text-[12px] text-[#E5FFFF] relative">
								Position Level:
								<Img
									src="/assets/yellowLevelIcon.svg"
									alt={'levelup-icon'}
									className="ml-[6px] mr-[2px] w-[14px] inline align-text-bottom h-[14px] object-contain"
								/>
								<span className="text-[14px] font-[500] text-white">
									{Math.floor(data?.position?.positionRequirement.levelThreshold ?? 0)}
								</span>
								<div className="md:hidden absolute top-[-2px] right-0">
									<RecruiterPositionCardMoreOptions
										positionId={String(positionId) ?? ''}
										positionStatus={data?.position?.positionStatus as PositionStatus}
										handleClosePosition={() => setIsCloseRecruiterPositionConfirmationModalOpen(true)}
										handleViewPosition={() => setIsPositionDrawerOpen(true)}
									/>
								</div>
							</div>
						) : null} */}

						{/* <div className="grow-2"></div> */}
						{/* <div
							className="sm:hidden select-none text-sm font-medium text-[#6698FA] cursor-pointer border-b border-solid border-[#6698FA]"
							onClick={() => setShowPositionDetail(!showPositionDetail)}
						>
							{showPositionDetailCtaText}
							<Img
								className={`${showPositionDetail ? 'rotate-180' : ''} inline-block ml-[2px] align-text-bottom`}
								src={'/assets/chevronDownBlue.svg'}
							/>
						</div> */}
					</div>

					{/* {showPositionDetail && data?.position ? (
						<div className="pt-6 sm:hidden" ref={positionDetailNodeRef}>
							<RecruiterPositionDetailBanner positionData={data?.position} />
						</div>
					) : null} */}

					<>
						{displayRecommendations ? (
							<>
								<div
									className={classNames(
										'flex gap-2 mt-[10px]',
										location.pathname.includes('pipeline') ? 'flex-row' : 'flex-col',
										selectedProfileIndex !== undefined ? 'hidden md:block' : 'mb-[10px]',
									)}
								>
									{selectedProfileIndex !== undefined && isMobile ? null : (
										<div
											className={classNames(
												'w-full flex flex-wrap items-center justify-between',
												selectedProfileIndex !== undefined && tab === CandidatesTabsEnum.CONNECTED
													? 'md:mb-[18px]'
													: '',
											)}
										>
											{/* Top Tabs for recommended and connected */}
											{hideRecommendations ? null : !location.pathname.includes('pipeline') ? (
												<div className="mt-[4px] md:mt-0 mb-[16px] md:mb-0 w-full md:max-w-[600px]">
													<RecruiterCandidatesTabsComponent
														tab={tab}
														setTab={setTab}
														totalRecommendations={totalRecommendations}
														totalAutoRecommended={totalAutoRecommended}
														totalConections={totalConections}
														totalRejected={totalRejected}
														isTourActive={isTourActive}
														onChange={value => {
															setShowMatchedOrShortListed(false);
															setBulkSelectedCandidates([]);
															setBulkSelect(false);
															resetPosition();
															setSelectedProfileIndex(undefined);
															searchParams.set('tab', value);
															setSearchParams(searchParams);
														}}
													/>
												</div>
											) : null}

											{hideRecommendations && !location.pathname.includes('pipeline') ? (
												<div className="flex items-center mb-[10px] md:mb-0 text-[#28293D] font-[600] text-lg">
													Applicants (
													{filteredCandidates?.length ? filteredCandidates?.length - 1 : filteredCandidates?.length})
												</div>
											) : null}
											<div className="w-full md:mt-0 md:max-w-[522px] flex items-center gap-[12px] justify-stretch">
												{/* Search Input */}
												<TextInput
													icon={() => <TbSearch color="#C7C9D9" />}
													className="w-full [&_input]:bg-white"
													placeholder="Search candidate (ex - Vibhav, Aman) and Student Code"
													name="search"
													defaultValue={search}
													rightIcon={() => (isPositionRecomendationDataLoading && search ? <Spinner /> : null)}
													onChange={e => debouncedSearchChangeHandler(e)}
												/>

												{/* Filters Drawer */}
												<FilterDrawer
													filterAppliedValue={hasActiveFilters || filterApplied}
													filterDrawerHeader={
														<h1 className="text-[#1C1C28] dark:text-inherit text-lg font-inter font-[500] px-5 pt-4 md:border-b md:pb-4">
															Filter by
														</h1>
													}
													filterDrawerBody={(filter: any) => {
														return (
															<div className="px-3 py-4">
																<RecruiterCandidatesFilters
																	positionId={positionId}
																	currentTab={tab}
																	onApply={() => {
																		filter.setFilterApplied(true);
																		setFilterApplied(true);
																	}}
																	onClear={() => {
																		filter.setFilterApplied(false);
																		setFilterApplied(false);
																	}}
																	onClose={() => {
																		filter.setShowFilterDrawer(false);
																		setShowFilterDrawer(false);
																	}}
																/>
															</div>
														);
													}}
												/>

												{/* Bulk select nav mobile */}
												{isMobile ? (
													<Slide in={bulkSelect} direction="down" unmountOnExit mountOnEnter>
														<div className="fixed top-0 inset-x-0 z-[50] h-[48px] bg-[#28293D] w-full text-white flex items-center justify-between px-4 py-3">
															<button
																onClick={() => {
																	resetPosition();
																	setBulkSelect(false);
																	setBulkSelectedCandidates([]);
																	setShowShareCandidatesForm(false);
																}}
															>
																<HiMiniArrowLeft className="h-[24px] w-[24px]" />
															</button>

															<button
																className={`text-white ${(tab === CandidatesTabsEnum.REJECTED || defaultBulkAction === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-auto-reject') && bulkSelectedCandidates?.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
																onClick={() => {
																	if (tab === CandidatesTabsEnum.REJECTED || defaultBulkAction === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-auto-reject') {
																		if (bulkSelectedCandidates?.length > 0) {
																			setBulkSelectedCandidates([]);
																		}
																		return;
																	}
																	bulkSelectedCandidates?.length == filteredCandidates?.length
																		? setBulkSelectedCandidates([])
																		: setBulkSelectedCandidates(filteredCandidates);
																}}
																disabled={(tab === CandidatesTabsEnum.REJECTED || defaultBulkAction === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-auto-reject') && bulkSelectedCandidates?.length === 0}
															>
																{bulkSelectedCandidates?.length == filteredCandidates?.length
																	? 'Clear all'
																	: 'Select all'}
															</button>
														</div>
													</Slide>
												) : null}
												{/* Bulk Select */}
												<Button
													onClick={() => {
														if (isTourActive) {
															return;
														}
														resetPosition();
														setShowShareCandidatesForm(false);
														setBulkSelect(p => {
															const newValue = !p;
															// When enabling bulk select, clear selection (auto-recommended users will be prevented from selection)
															if (newValue) {
																setBulkSelectedCandidates([]);
															} else {
																setBulkSelectedCandidates([]);
															}
															return newValue;
														});
													}}
													className={`walkthrough-fourth-element ${bulkSelect
														? 'text-white hover:!bg-[#1C1C28] bg-[#1C1C28] hover:dark:!bg-white dark:bg-white dark:text-black'
														: 'text-[#1C1C28]'
														} rounded-[8px] p-[8px] [&>span]:!p-0`}
													color="light"
												>
													<BiSelectMultiple className="w-[24px] h-[24px]" />
												</Button>

												{/* Bulk Select Drawer */}
												<Drawer
													hideBackdrop={isMobile}
													drawerHeight="max-content"
													minHeight="auto"
													maxHeight="90vh"
													isModal={!isMobile}
													disableScrollLock={isMobile}
													boxShadow="0px -8px 32px 0px #00000040"
													isOpen={
														isMobile
															? bulkSelectedCandidates?.length > 0
															: isRecommendationsPage
																? showShareCandidatesForm || !!defaultBulkAction
																: !!defaultBulkAction
													}
													onClose={() => {
														setShowShareCandidatesForm(false);
														if (isMobile) {
															setBulkSelect(false);
															resetPosition();
															setBulkSelectedCandidates([]);
														}
														setDefaultBulkAction(null);
														setSelectedAction('');
													}}
													header={
														<h1 className="text-[#1C1C28] dark:text-inherit text-lg font-inter font-[500] px-5 pt-4">
															Selected candidates ({bulkSelectedCandidates?.length})
														</h1>
													}
													body={
														<div className="px-3 py-4">
															<Avatar.Group className="justify-start -space-x-2">
																{bulkSelectedCandidates?.length > 5 ? (
																	<Avatar.Group className="justify-start -space-x-2">
																		{bulkSelectedCandidates
																			?.slice(0, 5)
																			.map((candidate, i) => (
																				<Avatar
																					key={i}
																					className="w-[40px] h-[40px] [&_div]:!w-full [&_div]:!h-full [&_img]:w-full [&_img]:h-full [&_img]:!ring-[2px] [&_img]:!ring-[#7777E7] [&_img]:object-cover [&>div>div]:!ring-[2px] [&>div>div]:!ring-[#7777E7]"
																					img={
																						(candidate?.user?.profile?.profileImageUrl &&
																							typeof candidate.user.profile.profileImageUrl === 'string'
																							? candidate.user.profile.profileImageUrl
																							: candidate?.user?.profile?.imageUrl &&
																								typeof candidate.user.profile.imageUrl === 'string'
																								? candidate.user.profile.imageUrl
																								: '') || ''
																					}
																					placeholderInitials={stringAvatar(
																						candidate?.user?.name.trim().toUpperCase() || '',
																					)}
																					rounded
																					stacked
																				/>
																			))}
																		<div className="font-inter font-[500] p-[10px] text-sm leading-[14px] w-[40px] h-[40px] rounded-full bg-[#CDF] ring-[#7777E7] ring-[1px] text-[#1F3343] z-[1] flex flex-wrap justify-center items-center text-center">
																			<span className="text-xl leading-[20px] font-[600] ">
																				+{bulkSelectedCandidates?.length - 5}
																			</span>
																		</div>
																	</Avatar.Group>
																) : (
																	<Avatar.Group className="justify-start -space-x-2">
																		{bulkSelectedCandidates.map((candidate, i) => (
																			<Avatar
																				key={i}
																				className="w-[40px] h-[40px] [&_div]:!w-full [&_div]:!h-full [&_img]:w-full [&_img]:h-full [&_img]:!ring-[2px] [&_img]:!ring-[#7777E7] [&_img]:object-cover [&>div>div]:!ring-[2px] [&>div>div]:!ring-[#7777E7]"
																				img={
																					(candidate?.user?.profile?.profileImageUrl &&
																						typeof candidate.user.profile.profileImageUrl === 'string'
																						? candidate.user.profile.profileImageUrl
																						: candidate?.user?.profile?.imageUrl &&
																							typeof candidate.user.profile.imageUrl === 'string'
																							? candidate.user.profile.imageUrl
																							: '') || ''
																				}
																				placeholderInitials={stringAvatar(
																					candidate?.user?.name.trim().toUpperCase() || '',
																				)}
																				rounded
																				stacked
																			/>
																		))}
																	</Avatar.Group>
																)}
															</Avatar.Group>

															<div className="h-[1px] bg-[#EBEBF0] my-[12px]"></div>

															{(tab === CandidatesTabsEnum.RECOMMENDATIONS || tab === CandidatesTabsEnum.REJECTED) && !location.pathname.includes('pipeline') ? (
																<>
																	{showShareCandidatesForm ? (
																		<div className="mt-[30px]">
																			<RecruiterShareCandidates
																				positionId={positionId}
																				bulkSelectedCandidates={bulkSelectedCandidates}
																				onSuccess={() => {
																					setBulkSelectedCandidates([]);
																					setShowShareCandidatesForm(false);
																					setBulkSelect(false);
																					resetPosition();
																				}}
																			/>
																		</div>
																	) : tab === CandidatesTabsEnum.REJECTED && defaultBulkAction === 'bulk-undo-reject' ? (
																		// Only show undo reject actions in Rejected tab
																		<div className="mt-[30px]">
																			<RecruiterCandidateUndoReject
																				userName="Candidates"
																				positionId={positionId}
																				isLoading={bulkActionFn.isLoading}
																				onSubmit={data => {
																					bulkActionFn.mutate({
																						action: 'bulk-undo-reject',
																						userIds: bulkSelectedCandidates.map(candidate => candidate?.user?._id),
																						positionId: positionId || '',
																					});
																				}}
																				onFinish={() => {
																					setBulkSelectedCandidates([]);
																					setShowShareCandidatesForm(false);
																					setBulkSelect(false);
																					resetPosition();
																					setDefaultBulkAction(null);
																				}}
																			/>
																		</div>
																	) : tab === CandidatesTabsEnum.REJECTED && defaultBulkAction === 'bulk-undo-auto-reject' ? (
																		// Only show undo auto reject actions in Rejected tab
																		<div className="mt-[30px]">
																			<RecruiterCandidateUndoAutoReject
																				userName="Candidates"
																				positionId={positionId}
																				isLoading={bulkActionFn.isLoading}
																				onSubmit={data => {
																					bulkActionFn.mutate({
																						action: 'bulk-undo-auto-reject',
																						userIds: bulkSelectedCandidates.map(candidate => candidate?.user?._id),
																						positionId: positionId || '',
																					});
																				}}
																				onFinish={() => {
																					setBulkSelectedCandidates([]);
																					setShowShareCandidatesForm(false);
																					setBulkSelect(false);
																					resetPosition();
																					setDefaultBulkAction(null);
																				}}
																			/>
																		</div>
																	) : tab === CandidatesTabsEnum.REJECTED ? (
																		<div className="mt-[30px]">
																			<div className="text-sm text-[#555770] mb-4">
																				Select an action to undo rejection for selected candidates
																			</div>
																			<div className="flex gap-2">
																				<Button
																					color="light"
																					className="flex-1"
																					onClick={() => {
																						setDefaultBulkAction('bulk-undo-reject');
																					}}
																				>
																					Undo Reject
																				</Button>
																				<Button
																					color="light"
																					className="flex-1"
																					onClick={() => {
																						setDefaultBulkAction('bulk-undo-auto-reject');
																					}}
																				>
																					Undo Auto-Reject
																				</Button>
																			</div>
																		</div>
																	) : (
																		<form
																			onSubmit={e => {
																				e.preventDefault();
																				if (selectedAction === 'share-profile') {
																					setShowShareCandidatesForm(true);
																				} else if (selectedAction === 'shortlist-profile') {
																					bulkActionFn.mutate({
																						action: 'shortlist-profile',
																						userIds: bulkSelectedCandidates.map(candidate => candidate?.user?._id),
																						positionId: positionId || '',
																					});
																				}
																			}}
																		>
																			<fieldset
																				className="grid grid-cols-2 max-w-md gap-4"
																				onChange={e => {
																					const target = e.target as HTMLInputElement;
																					if (target?.value) {
																						setSelectedAction(target?.value);
																					}
																				}}
																			>
																				<div className="flex items-center gap-2">
																					<Radio
																						className="text-[#7777E7] focus:ring-[#7777E7]"
																						id={'shareCandidates'}
																						name="bulkAction"
																						value={'share-profile'}
																						checked={selectedAction === 'share-profile'}
																					/>
																					<Label htmlFor={'shareCandidates'} className="text-sm font-[400] font-inter">
																						Share Candidates
																					</Label>
																				</div>
																				<div className="flex items-center gap-2">
																					<Radio
																						className="text-[#7777E7] focus:ring-[#7777E7] disabled:opacity-45 disabled:bg-[#d2d2d2]"
																						id={'shortlistCandidates'}
																						name="bulkAction"
																						value={'shortlist-profile'}
																						checked={selectedAction === 'shortlist-profile'}
																						disabled={positionHasExpired}
																					/>
																					<Label
																						htmlFor={'shortlistCandidates'}
																						className="text-sm font-[400] font-inter"
																					>
																						Shortlist Candidates
																					</Label>
																				</div>
																			</fieldset>

																			<Button
																				disabled={!selectedAction || bulkActionFn.isLoading}
																				color="purplePlaced"
																				type="submit"
																				className="mt-[24px] w-full bg-[#7777E7]"
																			>
																				{bulkActionFn.isLoading ? (
																					<div className="absolute flex justify-center inset-0 rounded-[inherit] items-center w-full h-full backdrop-blur-md">
																						<Spinner className="float-right" />
																					</div>
																				) : null}

																				{!selectedAction
																					? 'Select'
																					: selectedAction === 'shortlist-profile'
																						? 'Shortlist'
																						: 'Share Candidates'}
																			</Button>
																		</form>
																	)}
																</>
															) : (
																<RecruiterCandidatesBulkActionsOnConncetedUsers
																	bulkSelectedCandidates={bulkSelectedCandidates}
																	positionId={positionId}
																	defaultBulkAction={defaultBulkAction}
																	onFinish={() => {
																		setBulkSelectedCandidates([]);
																		setShowShareCandidatesForm(false);
																		setBulkSelect(false);
																		resetPosition();
																		setDefaultBulkAction(null);
																	}}
																/>
															)}
														</div>
													}
												/>
											</div>
										</div>
									)}

									<div
										className={classNames(
											'w-full flex-wrap justify-between items-center',
											location.pathname.includes('pipeline') ? 'hidden md:flex' : 'flex',
										)}
									>
										{selectedProfileIndex !== undefined && isMobile ? null : tab === CandidatesTabsEnum.RECOMMENDATIONS && !location.pathname.includes('pipeline') ? (
											<div className="min-h-[38px] flex items-center">
												<ToggleSwitch
													theme={{
														toggle: {
															checked: {
																color: {
																	blue: 'bg-[#7777E7] border-[#7777E7]',
																},
															},
														},
													}}
													checked={showMatchedOrShortListed}
													label="Show Shortlisted"
													onChange={() => {
														setShowMatchedOrShortListed(prev => !prev);
													}}
												/>
											</div>
										) : null}

										{/* Bulk select for desktop */}
										{isMobile ? null : (
											<Draggable
												handle="div"
												onDrag={(e, ui) => {
													const { x, y } = ui;
													setPosition({ x, y });
												}}
												position={position}
											>
												<Slide
													in={bulkSelect}
													direction="up"
													mountOnEnter
													unmountOnExit
													className="fixed z-[10] bottom-[10%] inset-x-[0] w-max max-w-[100vw] txl:max-w-[1280px] mx-auto ml-auto whitespace-pre flex items-center gap-2 rounded-full py-[12px] px-[16px] bg-[#28293D] dark:bg-[#374151]"
												>
													<div>
														<strong className="text-[#C7C9D9] cursor-move">
															<MdDragIndicator className="w-[24px] h-[24px]" />
														</strong>

														<div className="text-[#E4E4EB] flex items-center gap-1.5 mr-1">
															<span className="bg-[#7777E7] flex items-center justify-center p-1 text-center leading-[normal] w-full h-full max-w-[24px] max-h-[24px] min-w-[24px] min-h-[24px] rounded-full">
																{bulkSelectedCandidates.length}
															</span>
															candidates selected
														</div>

														<div className="mr-1">
															<button
																className={`text-[#9DBFF9] underline ${(tab === CandidatesTabsEnum.REJECTED || defaultBulkAction === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-auto-reject') && bulkSelectedCandidates?.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
																onClick={() => {
																	if (tab === CandidatesTabsEnum.REJECTED || defaultBulkAction === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-auto-reject') {
																		if (bulkSelectedCandidates?.length > 0) {
																			setBulkSelectedCandidates([]);
																		}
																		return;
																	}
																	bulkSelectedCandidates?.length == filteredCandidates?.length
																		? setBulkSelectedCandidates([])
																		: setBulkSelectedCandidates(filteredCandidates);
																}}
																disabled={(tab === CandidatesTabsEnum.REJECTED || defaultBulkAction === 'bulk-undo-reject' || defaultBulkAction === 'bulk-undo-auto-reject') && bulkSelectedCandidates?.length === 0}
															>
																{bulkSelectedCandidates?.length == filteredCandidates?.length
																	? 'Clear all'
																	: 'Select all'}
															</button>
														</div>

														<div className="relative overflow-auto">
															<div className="flex items-center">
																{/* Only show arrows if content is scrollable */}
																{(() => {
																	const container = document.querySelector('#bulk-action-container');
																	const hasScroll = container && container.scrollWidth > container.clientWidth;

																	return (
																		<>
																			{hasScroll ? (
																				<>
																					<button
																						className="absolute left-0 z-10 bg-[#28293D] dark:bg-[#374151] p-2 rounded-full"
																						onClick={() => {
																							if (container) {
																								container.scrollLeft -= 100;
																							}
																						}}
																					>
																						<HiMiniArrowLeft className="w-5 h-5 text-[#C7C9D9]" />
																					</button>

																					<div className="absolute left-0 top-0 bottom-0 z-[1] w-8 bg-gradient-to-r from-[#28293D] to-transparent dark:from-[#374151] pointer-events-none"></div>
																					<div className="absolute right-0 top-0 bottom-0 z-[1] w-8 bg-gradient-to-l from-[#28293D] to-transparent dark:from-[#374151] pointer-events-none"></div>

																					<button
																						className="absolute right-0 z-10 bg-[#28293D] dark:bg-[#374151] p-2 rounded-full"
																						onClick={() => {
																							if (container) {
																								container.scrollLeft += 100;
																							}
																						}}
																					>
																						<HiMiniArrowLeft className="w-5 h-5 text-[#C7C9D9] rotate-180" />
																					</button>
																				</>
																			) : null}
																			<div
																				className={classNames('overflow-auto relative', hasScroll ? 'px-8' : 'px-0')}
																				id="bulk-action-container"
																			>
																				{isRecommendationsPage ? (
																					<div className="flex w-fit items-center gap-2">
																						{tab === CandidatesTabsEnum.REJECTED ? (
																							<>
																								<Button
																									size="sm"
																									color="light"
																									disabled={!bulkSelectedCandidates.length}
																									className="focus:ring-[1px] focus:ring-gray-400"
																									onClick={() => {
																										setDefaultBulkAction('bulk-undo-reject');
																									}}
																								>
																									Undo Reject
																								</Button>
																								<Button
																									size="sm"
																									color="light"
																									disabled={!bulkSelectedCandidates.length}
																									className="focus:ring-[1px] focus:ring-gray-400"
																									onClick={() => {
																										setDefaultBulkAction('bulk-undo-auto-reject');
																									}}
																								>
																									Undo Auto-Reject
																								</Button>
																							</>
																						) : (
																							<>
																								<Button
																									size="sm"
																									color="light"
																									disabled={!bulkSelectedCandidates.length || bulkActionFn.isLoading}
																									className="focus:ring-[1px] focus:ring-gray-400"
																									onClick={() => {
																										setShowShareCandidatesForm(true);
																									}}
																								>
																									Share profiles
																								</Button>

																								<Button
																									size="sm"
																									color="light"
																									disabled={
																										!bulkSelectedCandidates.length ||
																										bulkActionFn.isLoading ||
																										positionHasExpired
																									}
																									className="focus:ring-[1px] focus:ring-gray-400"
																									onClick={() => {
																										bulkActionFn.mutate({
																											action: 'shortlist-profile',
																											userIds: bulkSelectedCandidates.map(
																												candidate => candidate?.user?._id,
																											),
																											positionId: positionId || '',
																										});
																									}}
																								>
																									{bulkActionFn.isLoading ? (
																										<div className="absolute flex justify-center inset-0 rounded-[inherit] items-center w-full h-full backdrop-blur-md">
																											<Spinner className="float-right" />
																										</div>
																									) : null}
																									Shortlist profiles
																								</Button>
																								{/* Removed undo reject actions from Recommendations tab - now only available in Rejected tab */}
																								{/* <Button
																									size="sm"
																									color="light"
																									disabled={!bulkSelectedCandidates.length}
																									className="focus:ring-[1px] focus:ring-gray-400"
																									onClick={() => {
																										setDefaultBulkAction('bulk-undo-reject');
																									}}
																								>
																									Undo Reject
																								</Button>
																								<Button
																									size="sm"
																									color="light"
																									disabled={!bulkSelectedCandidates.length}
																									className="focus:ring-[1px] focus:ring-gray-400"
																									onClick={() => {
																										setDefaultBulkAction('bulk-undo-auto-reject');
																									}}
																								>
																									Undo Auto-Reject
																								</Button> */}
																							</>
																						)}
																					</div>
																				) : (
																					<div className="flex w-fit items-center gap-2 justify-start">
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('schedule-interview');
																							}}
																						>
																							Schedule Interview
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('bulk-cancel-interview');
																							}}
																						>
																							Cancel Interview
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('share-profile');
																							}}
																						>
																							Share profiles
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('message');
																							}}
																						>
																							Send message
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('send-assignment');
																							}}
																						>
																							Send assignment
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('send-online-test');
																							}}
																						>
																							Send online test
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('move-to-next');
																							}}
																						>
																							Move to
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('bulk-reject');
																							}}
																						>
																							Reject Candidates
																						</Button>
																						{/* Removed undo reject actions from Applicants tab - now only available in Rejected tab */}
																						{/* <Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('bulk-undo-reject');
																							}}
																						>
																							Undo Reject
																						</Button>
																						<Button
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('bulk-undo-auto-reject');
																							}}
																						>
																							Undo Auto-Reject
																						</Button> */}
																						<Button
																							isProcessing={bulkActionFn.isLoading}
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								bulkActionFn.mutate({
																									action: 'download-resumes',
																									userIds: bulkSelectedCandidates.map(
																										candidate => candidate?.user?._id,
																									),
																									positionId: positionId || '',
																								});
																							}}
																						>
																							Download Resumes
																						</Button>
																						<Button
																							isProcessing={bulkActionFn.isLoading}
																							size="sm"
																							color="light"
																							disabled={!bulkSelectedCandidates.length}
																							className="focus:ring-[1px] focus:ring-gray-400"
																							onClick={() => {
																								setDefaultBulkAction('add-behavioural-flag');
																							}}
																						>
																							Assign Behavioural Flags
																						</Button>
																					</div>
																				)}
																			</div>
																		</>
																	);
																})()}
															</div>
														</div>

														<button
															className="text-[#C7C9D9]"
															onClick={() => {
																setBulkSelect(false);
																resetPosition();
																setBulkSelectedCandidates([]);
															}}
														>
															<IoClose className="w-[24px] h-[24px]" />
														</button>
													</div>
												</Slide>
											</Draggable>
										)}
									</div>
								</div>

								{/* Active Filter Chips */}
								{activeFilterChips.length > 0 && (
									<div className="w-full flex flex-wrap gap-2 mt-4 mb-4">
										{activeFilterChips.map((chip, index) => (
											<div
												key={index}
												className="text-sm font-[500] flex gap-1 items-center bg-[#E4E4EB] text-[#555770] pl-[8px] pr-[4px] py-[4px] rounded-[4px]"
											>
												<span className="max-w-[30ch] truncate">{chip.label}</span>
												<button
													onClick={() => handleRemoveFilter(chip.filterKey, chip.value)}
													className="hover:bg-gray-300 active:bg-gray-400 px-[6px] py-[2px] rounded-[4px] flex items-center"
													type="button"
												>
													<IoClose className="w-[14px] h-[14px]" />
												</button>
											</div>
										))}
									</div>
								)}

								{(!filteredCandidates.length && filterApplied && isPositionRecomendationDataLoading) ||
									(isPositionRecomendationDataLoading && search) ? (
									// <Loader />
									<NewCreatingPositionLoader
										showAnimation={true}
										progressBar={false}
										customClassCss="!w-[30%] mx-auto "
									/>
								) : location.pathname.includes('pipeline') && selectedProfileIndex === undefined && !isMobile ? (
									filteredCandidates.length ? (
										<RecruiterPipelineTable
											bulkSelect={bulkSelect}
											isPositionExpired={
												data?.position?.positionStatus === PositionStatus.CLOSED ||
												(data?.position?.expiresAt && positionHasExpired)
											}
											disableStartProcess={bulkSelect || data?.position?.positionStatus === PositionStatus.CLOSED}
											positionId={positionId ?? ''}
											candidates={filteredCandidates}
											bulkSelectedCandidates={bulkSelectedCandidates}
											setBulkSelectedCandidates={setBulkSelectedCandidates}
										/>
									) : (
										<div className=" mt-4 w-full h-full flex flex-col justify-center items-center">
											<div className="flex flex-col items-center justify-center">
												<div className="px-8">
													<div className="flex justify-center">
														<Img
															loading="lazy"
															src="/assets/noApplicationsEmptyState.svg"
															alt="noApplicationsEmptyState"
															width="160"
															height="160"
														/>
													</div>

													<div className="text-center mt-4 text-base font-medium text-[#28293D]">
														No applicants yet!
													</div>
													<div className="text-center mt-2 text-sm font-normal text-[#555770] dark:text-[#C7C9D9]">
														Talented individuals who will apply for this position will appear here.
													</div>
												</div>
											</div>
										</div>
									)
								) : (
									<>
										<div
											// style={{
											// 	height: positionDetailNodeRefClientHeight
											// 		? `calc(100vh - ${131 + positionDetailNodeRefClientHeight}px)`
											// 		: 'calc(100vh - 131px)',
											// }}
											className={`h-fit md:h-[calc(100vh-131px)] flex sm:flex-col gap-[20px] ${selectedProfileIndex === undefined ? `sm:h-max` : 'pb-4 sm:mx-[-16px]'
												} ${showPositionDetail ? 'border-t-[0px] border-[#555770] border-solid' : ''} `}
										>
											{/* left child */}
											<div
												className={`${selectedProfileIndex !== undefined
													? 'h-full overflow-y-scroll w-[430px] max-w-[430px] px-[10px] sm:hidden'
													: 'w-full'
													} `}
											>
												{/* Info note for Rejected tab */}
												{tab === CandidatesTabsEnum.REJECTED && (
													<div className="mb-4 p-4 bg-gradient-to-r from-[#FFF4E6] to-[#FFE8CC] border-2 border-[#FFB84D] rounded-lg shadow-sm">
														<div className="flex items-start gap-3">
															<div className="flex-shrink-0 mt-0.5">
																<svg className="w-5 h-5 text-[#FF8C00]" fill="currentColor" viewBox="0 0 20 20">
																	<path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
																</svg>
															</div>
															<div className="text-sm text-[#7C2D12] dark:text-[#FED7AA]">
																<span className="font-[700] text-[#C2410C] dark:text-[#FF8C00] text-base">Important Note:</span>
																<ul className="mt-2 ml-4 list-disc space-y-1.5">
																	<li>"Select all" is disabled while performing bulk undo reject/undo auto reject actions</li>
																	<li>Undo reject/undo auto reject is limited to a maximum of 2 times per candidate</li>
																</ul>
															</div>
														</div>
													</div>
												)}
												<div className="flex flex-wrap gap-7 sm:flex-col w-full sm:gap-4 py-2">
													{!isPositionRecomendationDataLoading && filteredCandidates.length ? (
														filteredCandidates.map((p, i) => {
															const currentProfileCard = p.user?.handler ?? '';
															const selectedProfileCard = handler ?? '';
															const isCardSelected = currentProfileCard === selectedProfileCard;
															const isSelected = bulkSelectedCandidates.find(
																candidate => candidate.user.handler === currentProfileCard,
															)
																? true
																: false;

															return (
																<div
																	key={p?.user?.handler}
																	className={`${selectedProfileIndex !== undefined
																		? 'w-full'
																		: 'sm:min-w-full min-w-[352px] md:w-[calc(33.3%-19px)]'
																		} relative isolate`}
																>
																	{!positionHasExpired &&
																		hideRecommendations &&
																		filteredCandidates?.length - 1 === i ? (
																		<div className="absolute z-[1] inset-0 my-auto mx-auto text-center flex items-center max-w-[80%] text-cemter text-[#28293D] text-base font-[500]">
																			Stay tuned for more candidates applying soon.
																		</div>
																	) : null}
																	<RecruiterCandidateCard
																		showBlur={
																			!positionHasExpired && hideRecommendations && filteredCandidates?.length - 1 === i
																		}
																		showShortListUi={
																			// For Rejected tab: show Recommendations UI for rejected users who were never shortlisted,
																			// show Applicants UI for rejected users who were shortlisted
																			tab === CandidatesTabsEnum.REJECTED
																				? !p?.application?.history?.some(h => h.newStatus === ApplicationStatus.SHORTLISTED)
																				: isRecommendationsPage
																		}
																		showBulkSelectUi={bulkSelect}
																		isSelected={isSelected}
																		isCardSelected={isCardSelected}
																		disableShortListApi={tab === CandidatesTabsEnum.AUTO_RECOMMENDED || !p?.application?._id}
																		disableViewProfile={
																			bulkSelect ||
																			data?.position?.positionStatus === PositionStatus.CLOSED ||
																			(!positionHasExpired &&
																				hideRecommendations &&
																				filteredCandidates?.length - 1 === i)
																		}
																		disableStartProcess={
																			bulkSelect ||
																			data?.position?.positionStatus === PositionStatus.CLOSED ||
																			(!positionHasExpired &&
																				hideRecommendations &&
																				filteredCandidates?.length - 1 === i) ||
																			p?.application?.pendingForAdminApproval
																		}
																		data={p}
																		isPositionExpired={
																			data?.position?.positionStatus === PositionStatus.CLOSED ||
																			(data?.position?.expiresAt && positionHasExpired)
																		}
																		isShortListed={
																			p?.application?.history
																				?.map(h => h.newStatus)
																				.includes(ApplicationStatus.OPENED_BY_EMPLOYER) ||
																				p?.application?.history
																					?.map(h => h.newStatus)
																					.includes(ApplicationStatus.SHORTLISTED)
																				? true
																				: false
																		}
																		placedElseWhere={p?.application?.status === ApplicationStatus.PLACED_ELSEWHERE}
																		isRejectedFromApplicants={
																			// Check if user is rejected and was previously shortlisted (from Applicants tab)
																			tab === CandidatesTabsEnum.REJECTED &&
																			(p?.application?.status === ApplicationStatus.REJECTED ||
																				p?.application?.status === ApplicationStatus.AUTO_REJECTED) &&
																			p?.application?.history?.some(h => h.newStatus === ApplicationStatus.SHORTLISTED)
																		}
																		handleViewProfile={e => {
																			if (bulkSelect) {
																				// Allow selection of rejected applications for bulk undo reject
																				if (isSelected)
																					setBulkSelectedCandidates(prev =>
																						prev.filter(people => people?.user?.handler !== currentProfileCard),
																					);
																				else setBulkSelectedCandidates(prev => [...prev, p]);
																			} else {
																				handleViewProfile(e);
																			}
																		}}
																		handler={p.user?.handler}
																	/>
																</div>
															);
														})
													) : (
														<div className=" mt-4 w-full h-full flex flex-col justify-center items-center">
															{tab === CandidatesTabsEnum.RECOMMENDATIONS ? (
																<div className="mt-[80px] sm:mt-[20px]">
																	<NoRecommendedCandidatesState
																		showShortlisted={showMatchedOrShortListed}
																		positionTitle={data?.position?.title ?? 'position'}
																	/>
																</div>
															) : tab === CandidatesTabsEnum.REJECTED ? (
																<div className="flex flex-col items-center justify-center">
																	<div className="px-8">
																		<div className="flex justify-center">
																			<Img
																				loading="lazy"
																				src="/assets/noApplicationsEmptyState.svg"
																				alt="noApplicationsEmptyState"
																				width="160"
																				height="160"
																			/>
																		</div>

																		<div className="text-center mt-4 text-base font-medium text-[#28293D]">
																			No rejected candidates yet!
																		</div>
																		<div className="text-center mt-2 text-sm font-normal text-[#555770] dark:text-[#C7C9D9]">
																			Rejected candidates from Recommendations and Applicants tabs will appear here.
																		</div>
																	</div>
																</div>
															) : !positionHasExpired && hideRecommendations ? (
																<div className="flex flex-col items-center justify-center">
																	<div className="px-8">
																		<div className="flex justify-center">
																			<Img
																				loading="lazy"
																				src="/assets/noApplicationsEmptyState.svg"
																				alt="noApplicationsEmptyState"
																				width="160"
																				height="160"
																			/>
																		</div>

																		<div className="text-center mt-4 text-base font-medium text-[#28293D]">
																			Position now active!
																		</div>
																		<div className="text-center mt-2 text-sm font-normal text-[#555770] dark:text-[#C7C9D9] max-w-[333px]">
																			LevelUp recommended candidates have been notified. The list updates dynamically as
																			candidates apply, a comprehensive list will be available in 8 hours.
																		</div>
																	</div>
																</div>
															) : (
																<>
																	<div className="flex flex-col items-center justify-center">
																		<div className="px-8">
																			<div className="flex justify-center">
																				<Img
																					loading="lazy"
																					src="/assets/noApplicationsEmptyState.svg"
																					alt="noApplicationsEmptyState"
																					width="160"
																					height="160"
																				/>
																			</div>

																			<div className="text-center mt-4 text-base font-medium text-[#28293D]">
																				No applicants yet!
																			</div>
																			<div className="text-center mt-2 text-sm font-normal text-[#555770] dark:text-[#C7C9D9]">
																				Talented individuals who will apply for this position will appear here.
																			</div>
																		</div>
																	</div>
																</>
															)}
														</div>
													)}

													{/* Create Empty Space for bulk select drawer */}
													{bulkSelectedCandidates?.length > 0 ? (
														<div className="pt-[300px] w-full md:hidden"></div>
													) : null}
												</div>

												{/* {!filterApplied &&
												!showMatchedOrShortListed &&
												filteredCandidates?.length &&
												tab === CandidatesTabsEnum.RECOMMENDATIONS ? (
													<RequestFurtherRecommendation positionId={positionId ?? ''} />
												) : null} */}
											</div>

											{/* right child */}
											<div
												className={`${selectedProfileIndex !== undefined
													? 'h-full md:overflow-y-scroll grow-2 w-full md:max-w-[calc(100%-430px)] md:pb-[60px] md:bg-[#E5F0FF] md:border border-[#7777E7] md:rounded-[12px] md:px-3'
													: 'hidden'
													} `}
											>
												{selectedProfileIndex !== undefined ? (
													<div className="">
														<CandidateProfile
															showBannerBg={false}
															hasShownInterest={
																filteredCandidates
																	? (filteredCandidates[selectedProfileIndex]?.application?.history
																		?.map(h => h.newStatus)
																		.includes(ApplicationStatus.APPLIED_BY_JOBSEEKER) ||
																		false) ??
																	false
																	: false
															}
															handler={
																filteredCandidates ? filteredCandidates[selectedProfileIndex]?.user?.handler ?? '' : ''
															}
															matchPercentage={
																filteredCandidates ? filteredCandidates[selectedProfileIndex]?.percentageMatch ?? 0 : 0
															}
														/>
													</div>
												) : null}
											</div>
										</div>

										{/* footer comp */}
										{selectedProfileIndex !== undefined ? (
											<ConnectWithCandidateComponent
												isConnecting={shortListUserFn.isLoading}
												hasUserConnected={hasUserConnected}
												handleConnect={handleConnect}
												disableConnect={
													tab === CandidatesTabsEnum.CONNECTED ||
													hasUserConnected ||
													shortListUserFn.isLoading ||
													!handler ||
													data?.position?.positionStatus === PositionStatus.CLOSED ||
													[
														ApplicationStatus.PLACED,
														ApplicationStatus.CLOSED_BY_ADMIN,
														ApplicationStatus.CLOSED_BY_RECRUITER,
													].includes(
														filteredCandidates[Number(selectedProfileIndex) + 1]?.application
															?.status as ApplicationStatus,
													) ||
													positionHasExpired
												}
												placedElseWhere={
													filteredCandidates[Number(selectedProfileIndex)]?.application?.history
														?.map(h => h.newStatus)
														.includes(ApplicationStatus.PLACED_ELSEWHERE) || false
												}
												disableLeftChevron={
													(filteredCandidates && filteredCandidates.length === 0) ||
													selectedProfileIndex === 0 ||
													shortListUserFn.isLoading
												}
												disableRightChevron={
													(filteredCandidates && filteredCandidates.length === 0) ||
													(filteredCandidates && selectedProfileIndex === filteredCandidates.length - 1) ||
													shortListUserFn.isLoading ||
													!!(
														hideRecommendations &&
														!positionHasExpired &&
														selectedProfileIndex === filteredCandidates.length - 2
													)
												}
												onClickLeftChevron={() => {
													sendTrackingEvent({
														event: 'recr_profile_toggle_left',
														eventLabel: location.pathname,
													});
													if (filteredCandidates) {
														const temp = filteredCandidates[Number(selectedProfileIndex) - 1];
														searchParams.set('handler', temp?.user?.handler);
														setSearchParams(searchParams);
													}
												}}
												onClickRightChevron={() => {
													sendTrackingEvent({
														event: 'recr_profile_toggle_right',
														eventLabel: location.pathname,
													});
													if (filteredCandidates) {
														const temp = filteredCandidates[Number(selectedProfileIndex) + 1];
														searchParams.set('handler', temp?.user?.handler);
														setSearchParams(searchParams);
													}
												}}
											/>
										) : null}
									</>
								)}
							</>
						) : (
							<div className="mt-10">
								<PositionUnderReviewState />
							</div>
						)}
					</>

					{/* {filteredCandidates[0] && filteredCandidates[0]?.user?.handler ? (
						<RecommendedCandidateModal
							isOpen={isRecommendedcandidatesModalOpen}
							onClose={handleSeenRecommendedCandidateModal}
							data={filteredCandidates[0]}
							handler={filteredCandidates[0]?.user?.handler}
						/>
					) : null} */}
				</>
			) : (
				<SuccessPage customStyleClass={'bg-[transparent]'} />
			)}

			<CloseRecruiterPositionConfirmationModal
				isOpen={isCloseRecruiterPositionConfirmationModalOpen}
				onClose={() => setIsCloseRecruiterPositionConfirmationModalOpen(false)}
				onConfirm={() => {
					setIsCloseRecruiterPositionConfirmationModalOpen(false);
					setIsCloseRecruiterPositionModal(true);
				}}
			/>
			<CloseRecruiterPositionModal
				positionId={positionId || ''}
				isOpen={isCloseRecruiterPositionModal}
				onClose={() => {
					setIsCloseRecruiterPositionModal(false);
					navigate('/');
				}}
			/>

			<RecruiterPositionDrawer
				isPositionDrawerOpen={isPositionDrawerOpen}
				positionId={positionId || ''}
				setIsPositionDrawerOpen={setIsPositionDrawerOpen}
				closeDrawer={() => setIsPositionDrawerOpen(false)}
			/>

			<RecruiterCreatePositionDrawer
				isOpen={recruiterCreatePosDrawerOpen}
				onClose={() => setRecruiterCreatePosDrawerOpen(false)}
			/>
		</>
	);
};

export default RecruiterCandidatesContainer2;
